import { type Monitor, Signal } from "@suse-o11y/signal";

/**
 * The state keeps track of expanded items.
 * It is necessary to keep track of them somewhere,
 * because it should sustain the values even if the component is unmounted.
 */
export class ToggleListState {
	private readonly set = Signal<ReadonlySet<string>>(new Set<string>());

	public isExpanded(monitor: Monitor, key: string): boolean {
		return this.set.read(monitor).has(key);
	}

	public expand(key: string, isExpanded: boolean): void {
		this.set.write((set) => {
			if (set.has(key) === isExpanded) {
				return set;
			}

			const clone = new Set(set);

			if (isExpanded) {
				clone.add(key);
			} else {
				clone.delete(key);
			}

			return clone;
		});
	}
}
